import { c as _c } from "react/compiler-runtime";
import { useErrorContext } from "@context-providers/error-boundary/error-handling-context";
import { useToast } from "@flat-ui";
import { useSceneSeatPermission } from "@components/table/members/assign-seats/use-scene-seat-permission";
import { MEMBER_SEAT_LABELS } from "@utils/member-seats-utils";
import { WorkspaceEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { getPrettyName } from "@utils/user-utils";

/** Where the seats are assigned from, as tracked, unless the caller says otherwise */
const DEFAULT_LOCATION = "workspace-members-table";

/** The prefix of the ID of the error toast, per seat */
const ERROR_ID_PREFIX = {
  xgSeat: "assignXgSeat",
  sceneSeat: "assignSceneSeat"
};
/**
 * Returns how to give a member a seat of the workspace subscription, with the request, its tracking
 * and the toasts about it.
 */
export function useAssignSeat() {
  const $ = _c(7);
  const {
    handleErrorWithToast
  } = useErrorContext();
  const {
    openToast
  } = useToast();
  const {
    trackEvent
  } = useTrackEvent();
  const {
    setSceneSeatPermission,
    setXgSeatPermission,
    refreshSeatUsage
  } = useSceneSeatPermission();
  let t0;
  if ($[0] !== handleErrorWithToast || $[1] !== openToast || $[2] !== refreshSeatUsage || $[3] !== setSceneSeatPermission || $[4] !== setXgSeatPermission || $[5] !== trackEvent) {
    const assignSeat = async function assignSeat(member, seat, t1) {
      const location = t1 === undefined ? DEFAULT_LOCATION : t1;
      const label = MEMBER_SEAT_LABELS[seat];
      trackAssignment(seat, location);
      ;
      try {
        await requestSeat(member, seat);
        openToast({
          title: `${label} seat assigned`,
          message: <><strong><var>{getPrettyName(member)}</var></strong>{" "}now holds a {label} seat.</>
        });
        return true;
      } catch (t2) {
        const error = t2;
        handleErrorWithToast({
          id: `${ERROR_ID_PREFIX[seat]}-${Date.now().toString()}`,
          title: `Cannot assign the ${label} seat`,
          error
        });
        return false;
      }
    };
    function trackAssignment(seat_0, location_0) {
      if (seat_0 === "xgSeat") {
        trackEvent({
          name: WorkspaceEvents.assignXgSeat,
          props: {
            location: location_0
          }
        });
        return;
      }
      trackEvent({
        name: WorkspaceEvents.assignSceneSeats,
        props: {
          numberOfMembers: 1,
          location: location_0
        }
      });
    }
    async function requestSeat(member_0, seat_1) {
      if (seat_1 === "xgSeat") {
        await setXgSeatPermission(member_0);
      } else {
        await setSceneSeatPermission(member_0, true);
      }
      refreshSeatUsage();
    }
    t0 = {
      assignSeat
    };
    $[0] = handleErrorWithToast;
    $[1] = openToast;
    $[2] = refreshSeatUsage;
    $[3] = setSceneSeatPermission;
    $[4] = setXgSeatPermission;
    $[5] = trackEvent;
    $[6] = t0;
  } else {
    t0 = $[6];
  }
  return t0;
}